import { Transform } from "class-transformer";
import { stringToBooleanNullable } from "../../types-transformers/boolean-transformers";
import { FileVariantsEnum } from '../../enums';

export class FilesFilter {
	@Transform(stringToBooleanNullable)
	public preview?: boolean;

	public variant?: FileVariantsEnum;
}
